/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdatePreferredPharmacyTypeErrorResponse,
  UpdatePreferredPharmacyTypeRequest,
  UpdatePreferredPharmacyTypeResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersPreferencesPharmacyType = (
  encounterId: number,
  updatePreferredPharmacyTypeRequest: UpdatePreferredPharmacyTypeRequest,
) => {
  return api<UpdatePreferredPharmacyTypeResponse>({
    url: `/api/encounters/${encounterId}/preferences/pharmacy-type`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePreferredPharmacyTypeRequest,
  });
};

export const getUpdateEncountersPreferencesPharmacyTypeMutationOptions = <
  TError = UpdatePreferredPharmacyTypeErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersPreferencesPharmacyType>>,
    TError,
    { encounterId: number; data: UpdatePreferredPharmacyTypeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersPreferencesPharmacyType>>,
  TError,
  { encounterId: number; data: UpdatePreferredPharmacyTypeRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersPreferencesPharmacyType'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersPreferencesPharmacyType>>,
    { encounterId: number; data: UpdatePreferredPharmacyTypeRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersPreferencesPharmacyType(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersPreferencesPharmacyTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersPreferencesPharmacyType>>
>;
export type UpdateEncountersPreferencesPharmacyTypeMutationBody =
  UpdatePreferredPharmacyTypeRequest;
export type UpdateEncountersPreferencesPharmacyTypeMutationError =
  UpdatePreferredPharmacyTypeErrorResponse;

export const useUpdateEncountersPreferencesPharmacyType = <
  TError = UpdatePreferredPharmacyTypeErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersPreferencesPharmacyType>>,
      TError,
      { encounterId: number; data: UpdatePreferredPharmacyTypeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersPreferencesPharmacyType>>,
  TError,
  { encounterId: number; data: UpdatePreferredPharmacyTypeRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersPreferencesPharmacyTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
